/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Команда • Понад 50 учасників',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Команда • Понад 50 учасників включно з вами',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Команда • 1 учасник} few {Команда • {0} учасники} many {Команда • {0} учасників} other {Команда • {0} учасників}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Команда • 1 учасник включно з вами} few {Команда • {0} учасники включно з вами} many {Команда • {0} учасників включно з вами} other {Команда • {0} учасників включно з вами}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Потрібен доступ до Confluence',
  'fabric.mention.error.defaultAction': 'Повторіть спробу за кілька секунд',
  'fabric.mention.error.defaultHeadline': 'Щось пішло не так',
  'fabric.mention.error.differentText': 'Спробуйте ввести інший текст',
  'fabric.mention.error.loginAgain': 'Спробуйте вийти й знову ввійти',
  'fabric.mention.noAccess.label': 'Немає доступу',
  'fabric.mention.noAccess.warning': '{name} не має доступу, тому не отримає сповіщення',
  'fabric.mention.unknow.user.error': 'Невідомий користувач {userId}'
};